export default __webpack_public_path__ + "static/media/Next IT - Comple (2).ff6aee7e.png";